import { Routes } from '@angular/router';
import { loginRoutes } from '@softapps/allgemein/login';
import { settingsRoutes } from '@softapps/allgemein/utils';
import { passwordRoutes } from '@softapps/allgemein/password';
import { moduleRoutes } from '@softapps/allgemein/modules';
import { bestellvorschlagRoutes } from '@softapps/mde/bestellvorschlag';
import { bestellerfassungRoutes } from '@softapps/mde/bestellerfassung';
import { etikettendruckRoutes } from '@softapps/mde/etikettendruck';
import { lagerInventurRoutes } from '@softapps/mde/inventur';
import { retourenRoutes } from '@softapps/mde/retouren';
import { warenverprobungRoutes } from '@softapps/mde/warenverprobung';
import { artikelInfoRoutes } from '@softapps/wws/artikel-info';
import { artikelvorratRoutes } from '@softapps/mde/artikelvorrat';
import { pmsStempelTerminalRoutes } from '@softapps/pms/stempel-terminal';
import { statusabfrageRoutes } from '@softapps/pms/statusabfrage';
import { stempelerfassungRoutes } from '@softapps/pms/stempelerfassung';
import { energietransportRoutes } from '@softapps/wws/energietransport';
import { gutscheinkartenRoutes } from '@softapps/handel/gutscheinkarten';
import { kundenabfrageRoutes } from '@softapps/wws/kundenabfrage';
import { dashboardRoutes } from '@softapps/allgemein/dashboard';
import { umsatzstatistikRoutes } from '@softapps/wws/umsatzstatistik';
import { offenePostenRoutes } from '@softapps/fibu/offene-posten';
import { mdeInventoryRoutes } from '@softapps/mde/inventory';
import { orderRoutes } from '@softapps/werkstatt/order';

export const shellRoutes: Routes = [
  //Allgemein
  ...moduleRoutes,
  ...settingsRoutes,

  //Wws
  // ...gesamtabfrageRoutes,
  ...stempelerfassungRoutes,

  // MDE
  ...bestellvorschlagRoutes,
  ...bestellerfassungRoutes,
  ...etikettendruckRoutes,
  ...mdeInventoryRoutes,
  ...retourenRoutes,
  ...warenverprobungRoutes,
  ...artikelvorratRoutes,
  ...artikelInfoRoutes,
  ...statusabfrageRoutes,

  ...energietransportRoutes,

  ...gutscheinkartenRoutes,

  ...kundenabfrageRoutes,

  ...dashboardRoutes,
  ...umsatzstatistikRoutes,
  ...offenePostenRoutes,

  // PMS
  ...pmsStempelTerminalRoutes,

  // Werkstatt
  ...orderRoutes,
];

export const publicRoutes: Routes = [
  ...loginRoutes,
  ...passwordRoutes,
  ...settingsRoutes,
];

/*
export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('@softapps/core').then((o) => o.ShellComponent),
    children: [
      //Allgemein
      ...moduleRoutes,
      ...settingsRoutes,

      //Wws
      // ...gesamtabfrageRoutes,
      ...stempelerfassungRoutes,

      // MDE
      ...bestellvorschlagRoutes,
      ...bestellerfassungRoutes,
      ...etikettendruckRoutes,
      ...lagerInventurRoutes,
      ...retourenRoutes,
      ...warenverprobungRoutes,
      ...artikelvorratRoutes,
      ...artikelInfoRoutes,
      ...statusabfrageRoutes,
      ...eslLinkRoutes,

      ...energietransportRoutes,

      ...gutscheinkartenRoutes,

      ...kundenabfrageRoutes,

      ...dashboardRoutes,
      ...umsatzstatistikRoutes,

      // PMS
      ...pmsStempelTerminalRoutes,
    ],
    canActivate: [AuthenticationGuard],
  },
  {
    path: '',
    loadComponent: () => import('@softapps/core').then((o) => o.PublicShellComponent),
    children: [...loginRoutes, ...passwordRoutes, ...settingsRoutes],
  },
];*/
